import { render } from "./TagsBlock.vue?vue&type=template&id=25b91ae8&scoped=true"
import script from "./TagsBlock.vue?vue&type=script&lang=js"
export * from "./TagsBlock.vue?vue&type=script&lang=js"

import "./TagsBlock.vue?vue&type=style&index=0&id=25b91ae8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b91ae8"]])

export default __exports__